<template>
  <div class="intro-bg">
    <top-navigation :show-home="false" :show-back="false" :show-avatar="false"></top-navigation>
    <div class="intro-text middle">
      <div class="intro-text-inner">
        <div class="intro-text-wrapper">
          <h1>WE NEED <span>YOUR HELP</span>!</h1>
          <p>
            Our planet’s wildlife is under threat, but together we can help! Play the games to boost your animal knowledge and discover how you can help save a species. For each game you complete, you’ll earn a collectable fact card to show to your friends!
          </p>
        </div>
        <div class="play-button">
          <button class="btn btn-primary mx-auto ng-default-btn" @click="load">PLAY</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import screenfull from 'screenfull'
import TopNavigation from '../components/TopNavigation'

export default {
  name: 'Intro',
  components: { TopNavigation },
  methods: {
    load () {
      if (screenfull.enabled && window.isMobile) {
        // screenfull.request()
      }
      this.$router.push('/avatar')
    }
  }
}
</script>

<style scoped>
  .intro-bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/img/intro.jpg");
    background-size: cover;
    background-position: center;
  }

  .intro-text {
    color: #fff;
    text-align: center;
  }

  .intro-text-wrapper {
    background-color: rgba(50, 50, 50, 0.8);
    padding: 10px;
    margin-bottom: 5vh;
  }

  .intro-text-inner {
    max-width: 70%;
    margin-left: auto;
    margin-right: auto;
  }

  .intro-text-inner p {
    font-size: 4.5vh;
    font-family: "Geograph-Regular";
    margin-bottom: 6vh;
  }

  .intro-text-inner h1 {
    font-size: 6vh;
    margin-bottom: 5vh;
    font-family: "Geograph-Bold";
  }

  .intro-text-inner h1 span {
    color: #ffcc00;
  }

  .play-button .btn {
    min-width: 280px;
  }
</style>
